import AxiosFactory from '@/entities/security/AxiosFactory'
import { UPDATE_USER_PASSWORD_URL } from '@/modules/changePassword/endpoints'
import ApiErrorFactory from '@/entities/errors/api_errors/ApiErrorsFactory'
import { UpdateUserPasswordPayloadI } from '@/modules/changePassword/types/api/UpdateUserPassword'

export default class ChangePasswordApi {
  async updateUserPassword(data: UpdateUserPasswordPayloadI) {
    try {
      const response = await AxiosFactory.createAxiosInstance().put(UPDATE_USER_PASSWORD_URL, data)
      return response.data
    } catch (e: unknown) {
      throw ApiErrorFactory.create(e)
    }
  }
}
